/**
 * Model labs whose display names start with S-Z, in catalog order.
 *
 * Generated by `pnpm logos:sync`; see `../model-labs.ts`.
 */
export const LABS_S_Z = [
    {
        id: 'sambanova',
        name: 'SambaNova',
        light: 'sambanova/sambanova-light.svg',
        dark: 'sambanova/sambanova-dark.svg',
    },
    {
        id: 'search1api',
        name: 'Search1API',
        light: 'search1api/search1api-light.svg',
        dark: 'search1api/search1api-dark.svg',
    },
    {
        id: 'searchapi',
        name: 'SearchApi',
        light: 'searchapi/searchapi-light.svg',
        dark: 'searchapi/searchapi-dark.svg',
    },
    {
        id: 'searxng',
        name: 'SearXNG',
        light: 'searxng/searxng-light.svg',
        dark: 'searxng/searxng-dark.svg',
    },
    {
        id: 'sensenova',
        name: 'SenseNova',
        light: 'sensenova/sensenova-light.svg',
        dark: 'sensenova/sensenova-dark.svg',
    },
    {
        id: 'siliconcloud',
        name: 'SiliconCloud',
        light: 'siliconcloud/siliconcloud-light.svg',
        dark: 'siliconcloud/siliconcloud-dark.svg',
    },
    {
        id: 'sillytavern',
        name: 'SillyTavern',
        light: 'sillytavern/sillytavern-light.svg',
        dark: 'sillytavern/sillytavern-dark.svg',
    },
    {
        id: 'skywork',
        name: 'Skywork',
        light: 'skywork/skywork-light.svg',
        dark: 'skywork/skywork-dark.svg',
    },
    { id: 'slock', name: 'Slock', light: 'slock/slock-light.svg', dark: 'slock/slock-dark.svg' },
    {
        id: 'smithery',
        name: 'Smithery',
        light: 'smithery/smithery-light.svg',
        dark: 'smithery/smithery-dark.svg',
    },
    {
        id: 'snowflake',
        name: 'Snowflake',
        light: 'snowflake/snowflake-light.svg',
        dark: 'snowflake/snowflake-dark.svg',
    },
    {
        id: 'sophnet',
        name: 'SophNet',
        light: 'sophnet/sophnet-light.svg',
        dark: 'sophnet/sophnet-dark.svg',
    },
    { id: 'sora', name: 'Sora', light: 'sora/sora-light.svg', dark: 'sora/sora-dark.svg' },
    { id: 'spark', name: 'Spark', light: 'spark/spark-light.svg', dark: 'spark/spark-dark.svg' },
    {
        id: 'speedai',
        name: 'SpeedAI',
        light: 'speedai/speedai-light.svg',
        dark: 'speedai/speedai-dark.svg',
    },
    {
        id: 'stability',
        name: 'Stability AI',
        light: 'stability/stability-light.svg',
        dark: 'stability/stability-dark.svg',
    },
    {
        id: 'statecloud',
        name: 'State Cloud',
        light: 'statecloud/statecloud-light.svg',
        dark: 'statecloud/statecloud-dark.svg',
    },
    {
        id: 'stepfun',
        name: 'StepFun',
        light: 'stepfun/stepfun-light.svg',
        dark: 'stepfun/stepfun-dark.svg',
    },
    {
        id: 'straico',
        name: 'Straico',
        light: 'straico/straico-light.svg',
        dark: 'straico/straico-dark.svg',
    },
    {
        id: 'streamlake',
        name: 'StreamLake',
        light: 'streamlake/streamlake-light.svg',
        dark: 'streamlake/streamlake-dark.svg',
    },
    {
        id: 'submodel',
        name: 'SubModel',
        light: 'submodel/submodel-light.svg',
        dark: 'submodel/submodel-dark.svg',
    },
    { id: 'suno', name: 'Suno', light: 'suno/suno-light.svg', dark: 'suno/suno-dark.svg' },
    { id: 'sync', name: 'Sync', light: 'sync/sync-light.svg', dark: 'sync/sync-dark.svg' },
    {
        id: 'targon',
        name: 'Targon',
        light: 'targon/targon-light.svg',
        dark: 'targon/targon-dark.svg',
    },
    {
        id: 'tavily',
        name: 'Tavily',
        light: 'tavily/tavily-light.svg',
        dark: 'tavily/tavily-dark.svg',
    },
    {
        id: 'tencent',
        name: 'Tencent',
        light: 'tencent/tencent-light.svg',
        dark: 'tencent/tencent-dark.svg',
    },
    {
        id: 'tencentcloud',
        name: 'Tencent Cloud',
        light: 'tencentcloud/tencentcloud-light.svg',
        dark: 'tencentcloud/tencentcloud-dark.svg',
    },
    {
        id: 'tiangong',
        name: 'Tiangong',
        light: 'tiangong/tiangong-light.svg',
        dark: 'tiangong/tiangong-dark.svg',
    },
    { id: 'tii', name: 'TII', light: 'tii/tii-light.svg', dark: 'tii/tii-dark.svg' },
    {
        id: 'together',
        name: 'Together AI',
        light: 'together/together-light.svg',
        dark: 'together/together-dark.svg',
    },
    {
        id: 'topazlabs',
        name: 'Topaz Labs',
        light: 'topazlabs/topazlabs-light.svg',
        dark: 'topazlabs/topazlabs-dark.svg',
    },
    { id: 'trae', name: 'Trae', light: 'trae/trae-light.svg', dark: 'trae/trae-dark.svg' },
    { id: 'tripo', name: 'Tripo', light: 'tripo/tripo-light.svg', dark: 'tripo/tripo-dark.svg' },
    { id: 'turix', name: 'Turix', light: 'turix/turix-light.svg', dark: 'turix/turix-dark.svg' },
    { id: 'udio', name: 'Udio', light: 'udio/udio-light.svg', dark: 'udio/udio-dark.svg' },
    {
        id: 'unstructured',
        name: 'Unstructured',
        light: 'unstructured/unstructured-light.svg',
        dark: 'unstructured/unstructured-dark.svg',
    },
    {
        id: 'upstage',
        name: 'Upstage',
        light: 'upstage/upstage-light.svg',
        dark: 'upstage/upstage-dark.svg',
    },
    { id: 'v0', name: 'v0', light: 'v0/v0-light.svg', dark: 'v0/v0-dark.svg' },
    {
        id: 'vectorizerai',
        name: 'Vectorizer AI',
        light: 'vectorizerai/vectorizerai-light.svg',
        dark: 'vectorizerai/vectorizerai-dark.svg',
    },
    {
        id: 'venice',
        name: 'Venice AI',
        light: 'venice/venice-light.svg',
        dark: 'venice/venice-dark.svg',
    },
    {
        id: 'vercel',
        name: 'Vercel',
        light: 'vercel/vercel-light.svg',
        dark: 'vercel/vercel-dark.svg',
    },
    {
        id: 'vertexai',
        name: 'Vertex AI',
        light: 'vertexai/vertexai-light.svg',
        dark: 'vertexai/vertexai-dark.svg',
    },
    { id: 'vidu', name: 'Vidu', light: 'vidu/vidu-light.svg', dark: 'vidu/vidu-dark.svg' },
    {
        id: 'viggle',
        name: 'Viggle',
        light: 'viggle/viggle-light.svg',
        dark: 'viggle/viggle-dark.svg',
    },
    { id: 'vllm', name: 'vLLM', light: 'vllm/vllm-light.svg', dark: 'vllm/vllm-dark.svg' },
    {
        id: 'volcengine',
        name: 'Volcengine',
        light: 'volcengine/volcengine-light.svg',
        dark: 'volcengine/volcengine-dark.svg',
    },
    {
        id: 'voyage',
        name: 'Voyage AI',
        light: 'voyage/voyage-light.svg',
        dark: 'voyage/voyage-dark.svg',
    },
    {
        id: 'wenxin',
        name: 'Wenxin',
        light: 'wenxin/wenxin-light.svg',
        dark: 'wenxin/wenxin-dark.svg',
    },
    {
        id: 'windsurf',
        name: 'Windsurf',
        light: 'windsurf/windsurf-light.svg',
        dark: 'windsurf/windsurf-dark.svg',
    },
    {
        id: 'workersai',
        name: 'Workersai',
        light: 'workersai/workersai-light.svg',
        dark: 'workersai/workersai-dark.svg',
    },
    {
        id: 'worldrouter',
        name: 'WorldRouter',
        light: 'worldrouter/worldrouter-light.svg',
        dark: 'worldrouter/worldrouter-dark.svg',
    },
    { id: 'xai', name: 'xAI', light: 'xai/xai-light.svg', dark: 'xai/xai-dark.svg' },
    {
        id: 'xiaomimimo',
        name: 'Xiaomi MiMo',
        light: 'xiaomimimo/xiaomimimo-light.svg',
        dark: 'xiaomimimo/xiaomimimo-dark.svg',
    },
    {
        id: 'xinference',
        name: 'Xinference',
        light: 'xinference/xinference-light.svg',
        dark: 'xinference/xinference-dark.svg',
    },
    { id: 'xpay', name: 'XPay', light: 'xpay/xpay-light.svg', dark: 'xpay/xpay-dark.svg' },
    {
        id: 'xuanyuan',
        name: 'XuanYuan',
        light: 'xuanyuan/xuanyuan-light.svg',
        dark: 'xuanyuan/xuanyuan-dark.svg',
    },
    {
        id: 'yandex',
        name: 'Yandex',
        light: 'yandex/yandex-light.svg',
        dark: 'yandex/yandex-dark.svg',
    },
    {
        id: 'youmind',
        name: 'YouMind',
        light: 'youmind/youmind-light.svg',
        dark: 'youmind/youmind-dark.svg',
    },
    {
        id: 'yuanbao',
        name: 'Yuanbao',
        light: 'yuanbao/yuanbao-light.svg',
        dark: 'yuanbao/yuanbao-dark.svg',
    },
    { id: 'zai', name: 'Z.ai', light: 'zai/zai-light.svg', dark: 'zai/zai-dark.svg' },
    {
        id: 'zapier',
        name: 'Zapier',
        light: 'zapier/zapier-light.svg',
        dark: 'zapier/zapier-dark.svg',
    },
    {
        id: 'zeabur',
        name: 'Zeabur',
        light: 'zeabur/zeabur-light.svg',
        dark: 'zeabur/zeabur-dark.svg',
    },
    {
        id: 'zencoder',
        name: 'Zencoder',
        light: 'zencoder/zencoder-light.svg',
        dark: 'zencoder/zencoder-dark.svg',
    },
    {
        id: 'zenmux',
        name: 'ZenMux',
        light: 'zenmux/zenmux-light.svg',
        dark: 'zenmux/zenmux-dark.svg',
    },
    { id: 'zhipu', name: 'Zhipu AI', light: 'zhipu/zhipu-light.svg', dark: 'zhipu/zhipu-dark.svg' },
];
//# sourceMappingURL=labs-s-z.js.map